import React from 'react';
import { urlFor } from '../../Utils';

export const HeartModalBackground = () => {
  const backgroundUrl = urlFor('static', { filename: 'img/logo_white.svg' });
  return (
    <div className='heart-logo' style={{
      height: '130%',
      zIndex: 10,
      width: '100%',
      position: 'absolute',
      backgroundPosition: 'center top',
      opacity: 0.1,
      transform: 'rotate(-20deg)',
      backgroundRepeat: 'no-repeat',
      backgroundImage: `url('${backgroundUrl}')`
    }} />
  );
};
